import styled from 'styled-components';

export const MultiSelectWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 0.8rem;
    color: ${({ theme }) => theme.colors.text.heading};

    label {
        font-weight: 500;
        font-size: 0.75rem;
        margin-bottom: 2px;
    }
    .dropdown-heading {
        height: 28px;
        .dropdown-heading-dropdown-arrow svg {
            height: 20px;
        }
        .dropdown-heading-value {
            color: ${({ theme }) => theme.colors.text.lightGrey};
            font-size: 0.8rem;
            * {
                color: ${({ theme }) => theme.colors.text.lightGrey};
            }
        }
    }

    .dropdown-content {
        .panel-content {
            background: ${({ theme }) => theme.colors.background.white};
        }

        label.select-item {
            margin: 0 2px 0 0;
            font-weight: 500;
            font-size: 0.8rem;
            font-weight: 400;
            border-bottom: 1px solid ${({ theme }) => theme.colors.border.ddd};
            background: ${({ theme }) => theme.colors.background.white};
        }

        .item-renderer > span {
            display: inline;
            padding-left: 3px;
        }
    }
`;
